import type { MagicSfx } from "@greg-chick/shared";
import { playSfxWith } from "../../../web/src/book/magicSfxCore";
import { loadManifest } from "./contentApi";

/**
 * 🔊 **관리자에서도 아이가 듣는 그 소리** — 나는 소리는 아이 화면 것을 **그대로** 쓴다.
 *
 * 🔴 여기서 다시 만들면 **운영자가 고른 소리와 아이가 듣는 소리가 갈린다.** 그림·자리에서 이미
 * 겪은 갈림이고(`previewParity`), 소리는 눈에 안 보여서 더 오래 안 들킨다.
 * 다른 것은 **파일을 찾는 길** 하나뿐이다(관리자는 게시본을 제 방식으로 읽는다).
 */
let files: Partial<Record<MagicSfx, string>> | null = null;
let asking = false;

function ensureFiles(): void {
  if (files || asking) return;
  asking = true;
  void loadManifest()
    .then((m) => {
      const out: Partial<Record<MagicSfx, string>> = {};
      for (const [k, e] of Object.entries(m.assets)) {
        if (!k.startsWith("sound.magic.") || !e?.url) continue;
        out[k.slice("sound.magic.".length) as MagicSfx] = e.url;
      }
      files = out;
    })
    .catch(() => {
      files = {};
    });
}

export function playMagicSfx(name: unknown): void {
  ensureFiles();
  playSfxWith(name, (n) => files?.[n]);
}

export { magicSfxOn, setMagicSfxOn, magicSfxLike } from "../../../web/src/book/magicSfxCore";
